import { Logger } from '@frontend/Logger';
import { AuthenticationSuccessResponse } from '@frontend/authentication-v2';

import ProvisioningClient from './provisioning-client';

export class DeviceAuthenticationManager {
    private static instance: DeviceAuthenticationManager | null;
    private blocked = false;
    public loggedIn: boolean;

    private constructor() {
        this.loggedIn = this.hasValidToken();
    }

    public static getInstance = (): DeviceAuthenticationManager => {
        if (!DeviceAuthenticationManager.instance) {
            DeviceAuthenticationManager.instance = new DeviceAuthenticationManager();
        }
        return DeviceAuthenticationManager.instance;
    };

    async authenticate(deviceId: string): Promise<AuthenticationSuccessResponse> {
        if (this.blocked) Logger.debug('Authentication manager is already being used by another process.');
        this.blocked = true;
        const credentials = await ProvisioningClient.provision(deviceId);

        this.saveTokenToStorage(credentials);
        Logger.log(credentials);
        this.blocked = false;
        this.loggedIn = true;
        return credentials;
    }

    async getTokenWhenReady(): Promise<AuthenticationSuccessResponse> {
        return new Promise((resolve, reject) => {
            if (!this.hasValidToken() && this.blocked === false) reject();
            if (this.blocked) {
                const interval = setInterval(() => {
                    if (this.blocked === false) {
                        resolve(this.getTokenFromStorage());
                        clearInterval(interval);
                    }
                }, 1000);
            } else resolve(this.getTokenFromStorage());
        });
    }

    async logout(callback?: () => any): Promise<void> {
        localStorage.removeItem('token');
        this.loggedIn = false;
        callback && callback();
    }

    //TODO does not actually check validity yet
    hasValidToken(): boolean {
        try {
            const credentials = this.getTokenFromStorage();
            return !!credentials.jwt_token;
        } catch (e) {
            return false;
        }
    }

    private getTokenFromStorage(): AuthenticationSuccessResponse {
        const token = localStorage.getItem('token');
        if (token == null) {
            Logger.error('Something went wrong trying te get the access token from localstorage.');
            throw new Error('No token information available.');
        }
        return JSON.parse(token) as AuthenticationSuccessResponse;
    }
    private saveTokenToStorage(token: AuthenticationSuccessResponse): void {
        localStorage.setItem('token', JSON.stringify(token));
    }
}
